import React from 'react'
import PageWrapper from 'wrappers/PageWrapper/PageWrapper'
import IntegrationIndexPage from './IntegrationIndexPage'

const IntegrationIndex = (props) => {
    return (
        <PageWrapper {...props} disableFooter>
            <IntegrationIndexPage {...props} />
        </PageWrapper>
    )
}

export default IntegrationIndex
